module.exports = __webpack_public_path__ + "static/media/city-bg.f630fbec.jpg";